@if (control() && !fieldData().readonly) {
    <mat-form-field
        class="cipo--width--full attachments-field"
        appearance="outline"
        (click)="addAttachments()"
        [ngClass]="{
            'cipo-mark-changed': fieldData().markChanged && valueChanged(),
        }">
        <mat-label>{{ fieldData().label ?? "" | translate }}</mat-label>
        <mat-chip-grid
            #chipGrid
            [formControl]="internalControl"
            class="cipo--overflow-y--auto"
            [style.maxHeight]="maxHeight()">
            @for (item of internalControl.value; track $index) {
                <mat-chip-row
                    (removed)="removeChip($index)"
                    (click)="openFile($index, $event)"
                    [value]="item"
                    [title]="item.name">
                    <img matChipAvatar [src]="item | imageSource" alt="" />
                    {{ item.name | translate }}

                    <mat-icon
                        [matMenuTriggerFor]="menu"
                        (click)="$event.stopPropagation()"
                        matChipTrailingIcon
                        class="cipo--cursor--pointer"
                        [matMenuTriggerData]="{ item: item }">
                        more_vert
                    </mat-icon>
                    <button matChipRemove [attr.aria-label]="'a11y.form.removeChip' | translate: { value: item.name }">
                        <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon>
                    </button>
                </mat-chip-row>
            }
            <input #chipInput matInput [formControl]="control()" [matChipInputFor]="chipGrid" />
        </mat-chip-grid>
        <div matSuffix fxLayout fxLayoutAlign="end center" fxLayoutGap="6px">
            @if (hasAttachments()) {
                <button
                    mat-icon-button
                    [matMenuTriggerFor]="actionsMenu"
                    [title]="'cipoFields.actions' | translate"
                    [attr.aria-label]="'cipoFields.actions' | translate"
                    (click)="$event.stopPropagation()">
                    <mat-icon aria-hidden="true">attachments</mat-icon>
                </button>
            } @else {
                <button
                    mat-icon-button
                    [title]="'cipoFields.attachFiles' | translate"
                    [attr.aria-label]="'cipoFields.attachFiles' | translate"
                    (click)="addAttachments(); $event.stopPropagation()">
                    <mat-icon aria-hidden="true">attachment</mat-icon>
                </button>
            }
            @if (fieldData().fieldDescription) {
                <mat-icon
                    class="material-icons-outlined cipo--cursor--help"
                    [title]="fieldData().fieldDescription | translate">
                    info
                </mat-icon>
            }
        </div>
        @if (control().invalid && control().touched) {
            <mat-error>
                {{ control().hasError("custom") ? control().errors.custom : ("errors.required" | translate) }}
            </mat-error>
        }
        @if (fieldData().hint) {
            <mat-hint>{{ fieldData().hint | translate }}</mat-hint>
        }
    </mat-form-field>
} @else if (attachments()) {
    <!-- In this case, fieldData can be undefined, because we might not have neither control nor fieldData -->
    @let _fieldData = fieldData() ?? {};
    <cipo-outline-field
        [label]="_fieldData.label"
        [error]="control()?.touched && control()?.invalid"
        [bgColorClass]="_fieldData.readonly ? `cipo-bg--${_fieldData.bgColor}` : null"
        [markChanged]="_fieldData.markChanged && valueChanged()"
        [required]="_fieldData.required"
        (click)="!_fieldData.readonly && addAttachments()">
        <div class="cipo--width--full" fxLayout fxLayoutAlign="space-between center">
            <mat-chip-set
                fxFlex="grow"
                class="attachments-chip-set cipo--overflow-y--auto"
                [style.maxHeight]="maxHeight()">
                @for (item of attachments(); track $index) {
                    @let showOnlyOne = _fieldData.showOnlyAttachmentByIndex !== undefined;
                    @let isSingleAttachment = showOnlyOne && _fieldData.showOnlyAttachmentByIndex === $index;
                    @if (!showOnlyOne || isSingleAttachment) {
                        <mat-chip
                            [style.backgroundColor]="item.bgColor"
                            class="cipo--border-radius--sm"
                            (removed)="removeChip($index)"
                            (click)="openFile($index, $event)"
                            [disabled]="item.disabled"
                            [class.highlighted]="item.highlighted"
                            [class.cipo--width--full]="isSingleAttachment"
                            [title]="item.name | translate">
                            <img matChipAvatar [src]="item | imageSource" alt="" />
                            {{ item.name | translate }}
                            <mat-icon
                                [matMenuTriggerFor]="menu"
                                (click)="$event.stopPropagation()"
                                matChipTrailingIcon
                                class="cipo--cursor--pointer-important"
                                [matMenuTriggerData]="{ item: item }">
                                more_vert
                            </mat-icon>
                            @if (!_fieldData.readonly) {
                                <button
                                    matChipRemove
                                    [attr.aria-label]="'a11y.form.removeChip' | translate: { value: item.name }">
                                    <mat-icon class="material-icons-outlined" aria-hidden="true">delete</mat-icon>
                                </button>
                            }
                        </mat-chip>
                    }
                }
            </mat-chip-set>
            @if (control() && hasAttachments()) {
                <button
                    mat-icon-button
                    class="m-l-md"
                    [matMenuTriggerFor]="actionsMenu"
                    [title]="'cipoFields.actions' | translate"
                    [attr.aria-label]="'cipoFields.actions' | translate"
                    (click)="$event.stopPropagation()">
                    <mat-icon aria-hidden="true">attachment</mat-icon>
                </button>
            }
        </div>
    </cipo-outline-field>
}
<mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
        @if (canDisplayInBrowser(item)) {
            <button mat-menu-item (click)="openNewTab(item)">{{ "cipoFields.openNewTab" | translate }}</button>
        }
        <button mat-menu-item (click)="download(item)">{{ "cipoFields.download" | translate }}</button>
        <button mat-menu-item [matMenuTriggerFor]="saveTo" [matMenuTriggerData]="{ item: item }">
            {{ "cipoFields.saveTo" | translate }}
        </button>
        @if (item.note) {
            <button mat-menu-item (click)="openNote(item)">{{ "cipoFields.seeNotes" | translate }}</button>
        }
    </ng-template>
</mat-menu>

<mat-menu #saveTo="matMenu">
    <ng-template matMenuContent let-item="item">
        <button mat-menu-item (click)="saveFileTo(item)">{{ driveModuleName() }}</button>
        @if (projectFilesModule()) {
            <button mat-menu-item (click)="saveFileTo(item, 'projectFiles')">{{ projectFilesModuleName() }}</button>
        }
    </ng-template>
</mat-menu>

<mat-menu #actionsMenu="matMenu">
    @if (!fieldData()?.readonly) {
        <button mat-menu-item (click)="addAttachments()">
            <mat-icon>attachment</mat-icon>
            {{ "cipoFields.attachFiles" | translate }}
        </button>
    }
    <button mat-menu-item (click)="onAddAttachmentNote()">
        <mat-icon class="material-icons-outlined">note_add</mat-icon>
        {{ "cipoFields." + (fieldData()?.readonly ? "seeNotes" : "addNote") | translate }}
    </button>
    <button mat-menu-item (click)="openDownloadDialog()">
        <mat-icon>file_download</mat-icon>
        {{ "cipoFields.download" | translate }}
    </button>
    <button mat-menu-item [matMenuTriggerFor]="bulkSaveTo">
        <mat-icon>save</mat-icon>
        {{ "cipoFields.saveTo" | translate }}
    </button>
</mat-menu>

<mat-menu #bulkSaveTo="matMenu">
    <button mat-menu-item (click)="openSaveToDialog()">{{ driveModuleName() }}</button>
    @if (projectFilesModule()) {
        <button mat-menu-item (click)="openSaveToDialog('projectFiles')">{{ projectFilesModuleName() }}</button>
    }
</mat-menu>
